import {
  IWidgetDynamic,
  DynamicFormula,
  DynamicFormulaNode,
  WidgetDynamicType
} from '../widget/dynamic/WidgetDynamic';
import { IProcedure } from '../Procedure';
import { MetadataLogic } from './MetadataLogic';
import { IWidget, WidgetType } from '../widget/Widget';
import { IRequestValues, IRequest } from '../request/Request';
import { formatMetadataValue } from './formatMetadataValue';
import {
  ContextualValue,
  formatContextualValue
} from '../contextual-value/ContextualValue';

export class DynamicMetadataCompiler {
  /**
   * Salva i valori dinamici all'interno dei `values`
   */
  static compile(procedure: IProcedure, request: IRequest) {
    procedure.widgets
      .filter(
        w =>
          w.type === WidgetType.Dynamic &&
          w.dynamic!.type === WidgetDynamicType.Dynamic
      )
      .forEach(widget => {
        const metadata = MetadataLogic.singleFromWidget(widget);
        const value = this.compileWidget(procedure, request, widget);

        request.values[metadata.id] = value;
      });
  }

  static compileWidget(
    procedure: IProcedure,
    request: IRequest,
    widget: IWidget
  ) {
    if (widget.type !== WidgetType.Dynamic)
      throw new Error('EDM-001 Metadato non valido per la compilazione dinamica.'); // prettier-ignore

    return this.compileFormula(procedure, request, widget.dynamic!.formula!);
  }

  static compileFormula(
    procedure: IProcedure,
    request: IRequest,
    formula: DynamicFormula
  ) {
    if (!formula) return '';
    let value = '';

    /**
     * Specifica se dobbiamo aggiungere uno spazio dopo il valore, in caso di
     * metadati o valori contestuali adiacenti.
     */
    let nextSpace = '';

    formula[0].children.forEach(node => {
      // Aggiungiamo gli spazi se necessario
      value += nextSpace;

      if (DynamicFormulaNode.isMetadata(node)) {
        const metadata = MetadataLogic.getInProcedure(
          procedure,
          node.metadataId
        );

        value += formatMetadataValue(metadata, request.values[node.metadataId]);
        nextSpace = ' ';
        return;
      }

      if (DynamicFormulaNode.isContextual(node)) {
        const contextual = ContextualValue.find(node.contextualValue);
        value += formatContextualValue(contextual.fromRequest(request));
        nextSpace = ' ';
        return;
      }

      if (DynamicFormulaNode.isText(node)) {
        value += node.text;
        nextSpace = '';
        return;
      }

      console.error(`EDM-002 Node: `, node);
      throw new Error('EDM-002 Tipo di campo non gestito per la compilazione dinamica'); // prettier-ignore
    });
    return value;
  }
}
